export default __webpack_public_path__ + "9b5db95fca76dab64392b2e97ef691c8.png";